angular.module('gym.reports').factory('BulkSuspendContactsService', function() {
  var BulkSuspendContactsService, data;
  data = {
    contact_ids: [],
    filters: {}
  };
  BulkSuspendContactsService = {
    get: function() {
      return data;
    },
    set: function(params) {
      data.initialized = true;
      data.filters = params.filters;
      return data.contact_ids = params.select_all_pages ? void 0 : params.contact_ids;
    }
  };
  return BulkSuspendContactsService;
});
